import { EntityResolved } from '@api';
import { WatchlistError } from '@terminal/stores/use-watchlist/watchlist-types';

export const prependEntitiesDedupedByTag = (
  newEntities: EntityResolved[],
  existing: EntityResolved[]
): EntityResolved[] => {
  const newByTag = new Map(newEntities.map(e => [e.tag, e]));
  return [...newByTag.values(), ...existing.filter(e => !newByTag.has(e.tag))];
};

interface ValidateListCreationProps {
  isAddMode: boolean;
  isEditMode: boolean;
  listName: string;
  rowSelection: Record<string, boolean>;
  unMappedEntitiesList: { input: string }[];
}

interface ValidationResult {
  isValid: boolean;
  tags: string[];
  unresolvedTags: string[];
  error?: WatchlistError;
}

export const validateListCreation = ({
  isAddMode,
  isEditMode,
  listName,
  rowSelection,
  unMappedEntitiesList,
}: ValidateListCreationProps): ValidationResult => {
  const isCreateMode = !isAddMode && !isEditMode;

  if (isCreateMode && !listName) {
    return {
      isValid: false,
      tags: [],
      unresolvedTags: [],
      error: WatchlistError.EmptyName,
    };
  }

  const tags = Object.keys(rowSelection).filter(tag => rowSelection[tag]);

  if ((isCreateMode || isEditMode) && !tags.length) {
    return {
      isValid: false,
      tags: [],
      unresolvedTags: [],
      error: WatchlistError.EmptyList,
    };
  }

  return {
    isValid: true,
    tags,
    unresolvedTags: unMappedEntitiesList.map(e => e.input),
  };
};
